export default "/images/62f3ff1b2753cde6996883d8de0ba08f.avif";